import React from 'react';
import { Link } from 'react-router-dom';
import { TextVariant } from '@naf/text';
import { GridCol } from '@naf/grid';
import { Button } from '@naf-simba/elements-buttons';
import { ArrowForward } from '@naf-simba/building-blocks-icons/Arrows';
import OrganizerHeader from '../OrganizerHeader';
import EventDetails from '../EventDetails';
import { TitleLink, Ingress, StyledImage } from './EventList.styles';
import { EventItemProps } from './EventList.types';
import S from '../../Styles';

const EventItem = ({ event, eventUrl }: EventItemProps) => {
  const { title, ingress, dateTimeIntervals, organizer, locationName, locationAddress, coordinates, image } = event;

  return (
    <>
      <GridCol s="12" m="6" l="6" xl="5">
        <Link to={eventUrl}>
          <StyledImage image={image} />
        </Link>
      </GridCol>
      <GridCol s="12" m="6" l="6" xl="5">
        {organizer && <OrganizerHeader organizer={organizer} />}
        <TitleLink to={eventUrl}>
          <S.TextNoMargin variant={TextVariant.Header2}>{title}</S.TextNoMargin>
        </TitleLink>
        <Ingress variant={TextVariant.BodyText}>{ingress}</Ingress>
        <EventDetails
          dateTimeIntervals={dateTimeIntervals}
          locationName={locationName}
          locationAddress={locationAddress}
          coordinates={coordinates}
        />
        <Button to={eventUrl} color="secondary" endIcon={ArrowForward}>
          Gå til arrangement
        </Button>
      </GridCol>
    </>
  );
};

export default EventItem;
